import { Flex, Text } from "theme-ui";

import { GradientBox } from "src/components/atoms";
import { IconMenuOptionProps } from "./IconMenuOption.d";

export const IconMenuOption: React.FC<IconMenuOptionProps> = ({
  active = true,
  customIcon,
  title,
  text,
  colors = ["secondary", "highlight", "tertiary", "accent"],
  ...rest
}) => {
  return (
    <GradientBox active={active} colors={colors} {...rest}>
      <Flex
        sx={{
          flexDirection: "column",
          alignItems: "center",
          cursor: "pointer",
          userSelect: "none",

          px: 1,
          py: [4, 4, 3],
        }}
      >
        <Text sx={{ color: active ? "primary" : "primaryMedium" }}>
          {customIcon}
        </Text>
        {title && (
          <Text
            sx={{
              color: active ? "primary" : "primaryMedium",
              fontSize: [3, 3, 4],
              fontWeight: "bold",
            }}
          >
            {title}
          </Text>
        )}
        {text && (
          <Text
            sx={{
              fontSize: [2, 2, 3],
              fontWeight: 500,
              textAlign: "center",
            }}
          >
            {text}
          </Text>
        )}
      </Flex>
    </GradientBox>
  );
};
